import React, { useState, useEffect } from "react";
import "./zayavki.css";

const API = "/php";

const Zayavki = ({ setChecked }) => {
    useEffect(() => { setChecked("2"); }, []);

    const [list, setList]         = useState([]);
    const [loading, setLoading]   = useState(false);
    const [zayavki, setzayavki]   = useState("0");
    const [selected, setSelected] = useState("");

    // Форма
    const [name, setName]       = useState("");
    const [location, setLocation] = useState("");
    const [phone, setPhone]     = useState("");
    const [typeZ, setTypeZ]     = useState("");
    const [message, setMessage] = useState("");

    const options = [
        "Хива","Хорезм","Турткуль","Беруний","Елликкала",
        "Кара Тау","Мангит","Нукус","Ходжели","Тахияташ",
        "Шуманай","Канлыкуль","Кунград","Муйнак","Барсакелмес",
    ];

    // =============================================
    // Загрузка заявок из MySQL
    // =============================================
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res  = await fetch(`${API}/get_zayavki.php`);
                const data = await res.json();
                if (data.status === "success") setList(data.data);
                else { console.error(data.message); setList([]); }
            } catch (err) {
                console.error("Fetch error:", err);
                setList([]);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // Активный фильтр (CSS)
    useEffect(() => {
        for (let i = 0; i <= 3; i++) {
            const el = document.querySelector(`.zayavki-box1-filter-span${i + 1}`);
            if (el) el.classList.toggle("active", zayavki === String(i));
        }
    }, [zayavki]);

    const toggleAddZayavka = () => {
        document.querySelector(".addZayavka")?.classList.toggle("active");
    };

    // =============================================
    // Нормализация полей MySQL → JSX
    // =============================================
    const normalizeItem = (item) => ({
        ...item,
        nameClient:        item.nameClient        ?? item.name_client         ?? "",
        locationClient:    item.locationClient    ?? item.location_client     ?? "",
        phoneNumberClient: item.phoneNumberClient ?? item.phone_number_client ?? "",
        typeRequest:       item.typeRequest       ?? item.type_request        ?? "",
        message:           item.message           ?? "",
        status:            item.status            ?? "1",
    });

    // =============================================
    // Добавление новой заявки
    // =============================================
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim() || !location.trim() || !phone.trim() || !typeZ.trim()) {
            alert("Заполните все обязательные поля");
            return;
        }
        const payload = { name, location, phone, type: typeZ, message };
        try {
            const res  = await fetch(`${API}/add_to_zayavki.php`, {
                method:  "POST",
                headers: { "Content-Type": "application/json" },
                body:    JSON.stringify(payload)
            });
            const json = await res.json();
            if (json.ok) {
                setList(prev => [normalizeItem(json.item), ...prev]);
                setName(""); setLocation(""); setPhone(""); setTypeZ(""); setMessage("");
                toggleAddZayavka();
            } else {
                alert("Ошибка: " + (json.error || "unknown"));
            }
        } catch (err) {
            console.error(err);
            alert("Ошибка сети");
        }
    };

    // =============================================
    // Обновление статуса заявки
    // =============================================
    const handleStatusChange = async (id, newStatus) => {
        // Обновляем локально сразу
        setList(prev => prev.map(item =>
            item.id === id ? { ...item, status: newStatus } : item
        ));
        try {
            const res    = await fetch(`${API}/add_to_zayavki.php`, {
                method:  "POST",
                headers: { "Content-Type": "application/json" },
                body:    JSON.stringify({ id, status: newStatus })
            });
            const result = await res.json();
            if (!result.ok) {
                alert("Не удалось сохранить статус на сервере");
            }
        } catch (err) {
            console.error("Ошибка сети:", err);
            alert("Не удалось соединиться с сервером");
        }
    };

    return (
        <section className="zayavki">
            {/* ----- Форма добавления ----- */}
            <div className="addZayavka" onClick={toggleAddZayavka}>
                <div className="addZayavka-flex" onClick={(e) => e.stopPropagation()}>
                    <span className="addZayavka-flex-box">
                        <h6>Имя клиента:</h6>
                        <input value={name} type="text" onChange={(e) => setName(e.target.value)} />
                    </span>
                    <span className="addZayavka-flex-box">
                        <h6>Местоположение:</h6>
                        <select value={location} onChange={(e) => setLocation(e.target.value)}>
                            <option value="">Выберите....</option>
                            {options.map((opt, idx) => (
                                <option key={idx} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </span>
                    <span className="addZayavka-flex-box">
                        <h6>Тел.номер:</h6>
                        <input value={phone} type="text" onChange={(e) => setPhone(e.target.value)} />
                    </span>
                    <span className="addZayavka-flex-box">
                        <h6>Тип заявки:</h6>
                        <input value={typeZ} type="text" onChange={(e) => setTypeZ(e.target.value)} />
                    </span>
                    <span className="addZayavka-flex-box">
                        <h6>Доп. информация:</h6>
                        <input value={message} type="text" onChange={(e) => setMessage(e.target.value)} />
                    </span>
                    <div className="addZayavka-flex-box-button">
                        <button onClick={handleSubmit}>Добавить заявку</button>
                    </div>
                </div>
            </div>

            {/* ----- Основной блок ----- */}
            <div className="zayavki-flex">
                <div className="zayavki-box1">
                    <div className="zayavki-box1-filter">
                        <span className="zayavki-box1-filter-span zayavki-box1-filter-span1" onClick={() => setzayavki("0")}>Все</span>
                        <span className="zayavki-box1-filter-span zayavki-box1-filter-span2" onClick={() => setzayavki("1")}>В процессе</span>
                        <span className="zayavki-box1-filter-span zayavki-box1-filter-span3" onClick={() => setzayavki("2")}>Успешно</span>
                        <span className="zayavki-box1-filter-span zayavki-box1-filter-span4" onClick={() => setzayavki("3")}>Отказано</span>
                    </div>
                    <div className="zayavki-box1-filter2">
                        <h6>Местоположение:</h6>
                        <select value={selected} onChange={(e) => setSelected(e.target.value)}>
                            <option value="">Все</option>
                            {options.map((opt, idx) => (
                                <option key={idx} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <div className="zayavki-box1-addbutton" onClick={toggleAddZayavka}>+ Добавить заявку</div>
                </div>

                {/* ----- Таблица ----- */}
                {loading ? <div className="loader"></div> : (
                    <table className="zayavki-list-table">
                        <thead>
                            <tr className="zayavki-list-table-sticky">
                                <th>№</th>
                                <th>Имя</th>
                                <th>Дата</th>
                                <th>Местоположение</th>
                                <th>Тел.Номер</th>
                                <th>Тип заявки</th>
                                <th>Доп. Информация</th>
                                <th>Статус</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list
                                .map(normalizeItem)
                                .sort((a, b) => b.id - a.id)
                                .filter(koks => {
                                    const matchLocation = (koks.locationClient || "").toLowerCase().includes(selected.toLowerCase());
                                    let   matchStatus   = true;
                                    if      (zayavki === "1") matchStatus = koks.status == "1";
                                    else if (zayavki === "2") matchStatus = koks.status == "2";
                                    else if (zayavki === "3") matchStatus = koks.status == "3";
                                    return matchLocation && matchStatus;
                                })
                                .map(koks => (
                                    <tr key={koks.id}
                                        style={{
                                            color:           koks.status == 3 ? "red" : koks.status == 2 ? "green" : "",
                                            backgroundColor: koks.status == 3 ? "#ffe5e5" : koks.status == 2 ? "#96ebc556" : ""
                                        }}>
                                        <td>{koks.id}</td>
                                        <td>{koks.nameClient}</td>
                                        <td>{koks.date}</td>
                                        <td>{koks.locationClient}</td>
                                        <td>{koks.phoneNumberClient}</td>
                                        <td>{koks.typeRequest}</td>
                                        <td>{koks.message}</td>
                                        <td>
                                            <select
                                                className="zayavki-list-table-sticky-select"
                                                value={koks.status}
                                                onChange={(e) => handleStatusChange(koks.id, e.target.value)}
                                            >
                                                <option value="1">В процессе</option>
                                                <option value="2">Успешно</option>
                                                <option value="3">Отказано</option>
                                            </select>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                )}
            </div>
        </section>
    );
};

export default Zayavki;
